import Icon from '../components/Icon.vue'

Icon.register({
  child: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M120 72c0-39.8 32.2-72 72-72s72 32.2 72 72c0 39.8-32.2 72-72 72s-72-32.2-72-72zM374.6 73.4c12.5 12.5 12.5 32.8 0 45.3l-94.6 94.6v266.7c0 17.7-14.3 32-32 32h-16c-17.7 0-32-14.3-32-32v-112h-16v112c0 17.7-14.3 32-32 32h-16c-17.7 0-32-14.3-32-32v-266.7l-94.6-94.6c-12.5-12.5-12.5-32.8 0-45.3 12.5-12.5 32.8-12.5 45.3 0l86.6 86.6h101.5l86.6-86.6c12.5-12.5 32.8-12.5 45.3 0z'
      }
    ]
  }
})
